export const reorderArray = (list, fromIndex, toIndex) => {
  const result = [...list];
  const [movedItem] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, movedItem);
  return result;
};
